import React, { useState, useEffect } from "react";
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, Label, Input, Row } from "reactstrap";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";

import {
    listMainCategoryByParams,
    industryGroupDropdown,
    createMainCategory,
    updateMainCategory,
    deleteMainCategory,
    getMainCategoryById
} from "../../api/mainCategory.api";

import StatusBadge from "../../components/StatusBadge";


const MainCategoryMaster = () => {

    const initialState = {
        category_name: "",
        industry_group_id: "",
        sequence: "",
        is_active: true
    };

    const [values, setValues] = useState(initialState);
    const [data, setData] = useState([]);
    const [groups, setGroups] = useState([]);

    const [loading, setLoading] = useState(false);
    const [query, setQuery] = useState("");
    const [filter, setFilter] = useState(true);

    const [modal_add, setModalAdd] = useState(false);
    const [modal_edit, setModalEdit] = useState(false);
    const [modal_delete, setModalDelete] = useState(false);

    const [_id, set_Id] = useState("");
    const [remove_id, setRemove_id] = useState("");

    const [pageNo, setPageNo] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalRows, setTotalRows] = useState(0);



    const fetchData = async () => {

        setLoading(true);

        const skip = (pageNo - 1) * perPage;

        const res = await listMainCategoryByParams({
            skip,
            per_page: perPage,
            match: query,
            is_active: filter
        });

        if (res.data.data.length > 0) {

            const result = res.data.data[0];

            setData(result.data);
            setTotalRows(result.count);

        } else {
            setData([]);
        }

        setLoading(false);

    };



    useEffect(() => {

        industryGroupDropdown()
            .then(res => setGroups(res.data.data || []));

        fetchData();

    }, [query, pageNo, perPage, filter]);



    const handleAdd = async (e) => {

        e.preventDefault();

        await createMainCategory(values);

        toast.success("Category Added");

        setModalAdd(false);

        setValues(initialState);

        fetchData();

    };



    const handleEdit = async (id) => {

        set_Id(id);

        const res = await getMainCategoryById(id);

        setValues(res.data.data);

        setModalEdit(true);

    };



    const handleUpdate = async (e) => {

        e.preventDefault();

        await updateMainCategory(_id, values);

        toast.success("Updated Successfully");

        setModalEdit(false);

        setValues(initialState);

        fetchData();

    };



    const handleDelete = async () => {

        await deleteMainCategory(remove_id);

        toast.success("Deleted");

        setModalDelete(false);

        fetchData();

    };



    const columns = [

        { name: "Sr No", selector: (r, i) => i + 1, width: "80px" },

        { name: "Category Name", selector: r => r.category_name, grow: 2, style: { fontWeight: "600" } },

        { name: "Industry Group", selector: r => r.group_name },

        { name: "Seq", selector: r => r.sequence, center: true },

        {
            name: "Status",
            center: true,
            cell: (r) => (
                <StatusBadge status={r.is_active ? "ACTIVE" : "INACTIVE"} />
            )
        },

        {
            name: "Actions",
            right: true,
            cell: (row) => (
                <div className="d-flex gap-3">

                    <button
                        className="btn btn-link p-0 text-muted"
                        onClick={() => handleEdit(row.id)}
                    >
                        🖊️
                    </button>

                    <button
                        className="btn btn-link p-0 text-danger"
                        onClick={() => { setRemove_id(row.id); setModalDelete(true) }}
                    >
                        🗑️
                    </button>

                </div>
            )
        }

    ];



    return (

        <div style={{ backgroundColor: "#ffffff", padding: "clamp(15px, 3vw, 24px)", borderRadius: "12px", border: "1px solid #e5e7eb" }}>

            <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">

                <div>
                    <h4 className="fw-bold m-0" style={{ color: "#112347" }}>Category Management</h4>
                    <p className="text-muted small m-0">Organize Product Categories</p>
                </div>

                <button
                    className="btn btn-dark fw-bold px-4 py-2"
                    style={{ backgroundColor: "#112347", borderRadius: "8px" }}
                    onClick={() => { setValues(initialState); setModalAdd(true) }}
                >
                    + Add Category
                </button>

            </div>



            <Row className="mb-4 align-items-center g-3">

                <Col xs="12" md="4" className="position-relative">

                    <span className="position-absolute translate-middle-y top-50 ms-3 text-muted">🔍</span>

                    <Input
                        placeholder="Search Categories..."
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        style={{ backgroundColor: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "8px", paddingLeft: "40px" }}
                    />

                </Col>

                <Col xs="12" md="3">

                    <div className="form-check">

                        <Input
                            type="checkbox"
                            className="form-check-input"
                            checked={filter}
                            onChange={(e) => setFilter(e.target.checked)}
                        />

                        <Label className="form-check-label ms-2">
                            Active
                        </Label>

                    </div>

                </Col>

            </Row>



            <div className="table-responsive border rounded-3 overflow-hidden">

                <DataTable
                    columns={columns}
                    data={data}
                    progressPending={loading}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangePage={setPageNo}
                    onChangeRowsPerPage={setPerPage}
                />

            </div>



            {/* ADD MODAL */}

            <Modal isOpen={modal_add} toggle={() => setModalAdd(false)} centered>

                <ModalHeader>Add Category</ModalHeader>

                <ModalBody>

                    <Label>Category Name</Label>

                    <Input
                        value={values.category_name}
                        onChange={(e) => setValues({ ...values, category_name: e.target.value })}
                    />

                    <Label className="mt-2">Industry Group</Label>

                    <Input
                        type="select"
                        value={values.industry_group_id}
                        onChange={(e) => setValues({ ...values, industry_group_id: e.target.value })}
                    >

                        <option value="">Select</option>

                        {groups.map(g => (
                            <option key={g.id} value={g.id}>{g.group_name}</option>
                        ))}

                    </Input>

                    <Label className="mt-2">Sequence</Label>

                    <Input
                        type="number"
                        value={values.sequence}
                        onChange={(e) => setValues({ ...values, sequence: e.target.value })}
                    />

                    <Label className="mt-3">Active</Label>

                    <div className="form-check">

                        <Input
                            type="checkbox"
                            checked={values.is_active}
                            onChange={(e) => setValues({ ...values, is_active: e.target.checked })}
                        />

                        <Label className="ms-2">Is Active</Label>

                    </div>

                </ModalBody>

                <ModalFooter>

                    <button
                        className="btn btn-dark w-100"
                        style={{ backgroundColor: "#112347" }}
                        onClick={handleAdd}
                    >
                        Save Category
                    </button>

                </ModalFooter>

            </Modal>



            {/* EDIT MODAL */}

            <Modal isOpen={modal_edit} toggle={() => setModalEdit(false)} centered>

                <ModalHeader>Edit Category</ModalHeader>

                <ModalBody>

                    <Label>Category Name</Label>

                    <Input
                        value={values.category_name}
                        onChange={(e) => setValues({ ...values, category_name: e.target.value })}
                    />

                    <Label className="mt-2">Industry Group</Label>

                    <Input
                        type="select"
                        value={values.industry_group_id}
                        onChange={(e) => setValues({ ...values, industry_group_id: e.target.value })}
                    >

                        <option value="">Select</option>

                        {groups.map(g => (
                            <option key={g.id} value={g.id}>{g.group_name}</option>
                        ))}

                    </Input>

                    <Label className="mt-2">Sequence</Label>

                    <Input
                        type="number"
                        value={values.sequence}
                        onChange={(e) => setValues({ ...values, sequence: e.target.value })}
                    />

                    <Label className="mt-3">Active</Label>

                    <div className="form-check">

                        <Input
                            type="checkbox"
                            checked={values.is_active}
                            onChange={(e) => setValues({ ...values, is_active: e.target.checked })}
                        />

                        <Label className="ms-2">Is Active</Label>

                    </div>

                </ModalBody>

                <ModalFooter>

                    <button
                        className="btn btn-dark w-100"
                        style={{ backgroundColor: "#112347" }}
                        onClick={handleUpdate}
                    >
                        Update Category
                    </button>

                </ModalFooter>

            </Modal>



            {/* DELETE MODAL */}

            <Modal isOpen={modal_delete} toggle={() => setModalDelete(false)} centered>

                <ModalHeader>Delete Category</ModalHeader>

                <ModalBody>
                    Are you sure you want to delete this category?
                </ModalBody>

                <ModalFooter>

                    <button className="btn btn-danger" onClick={handleDelete}>
                        Delete
                    </button>

                </ModalFooter>

            </Modal>

        </div>

    );

};

export default MainCategoryMaster;